import { render, staticRenderFns } from "./SubSectionHeader.vue?vue&type=template&id=6cb75fa1"
import script from "./SubSectionHeader.vue?vue&type=script&lang=js"
export * from "./SubSectionHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports